import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getUserById } from '../../services/UsersService';
import { User } from '../../types/Users';
import { FeaturesManagement } from '../../../featuresControl';

function useGetUserById(fleetId: string, userId?: string): UseQueryResult<User> {
  return useQuery(
    ['users'],
    async (): Promise<User> => getUserById(fleetId, userId || ''),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
      enabled: !!userId && !!fleetId,
    },
  );
}

export default useGetUserById;
